import { isNil } from 'lodash';
import { useEffect, useState } from 'react';
import { TextInput } from 'react-native';
import { Field } from '@shared/data/entity/fields/Field';
import { API } from '@shared/types/api';

interface Props {
  field: Field | null;
  component: API.AnyComponent;
  updateField: (componentId: string, field: Field) => void;
}

export function GenericEditJsonField({ field, component, updateField }: Props) {
  const [blob, setBlob] = useState(
    !isNil(field) && 'jsonBlob' in field ? field.jsonBlob : component.type,
  );

  useEffect(() => {
    if (!isNil(field) && 'jsonBlob' in field) {
      setBlob(field.jsonBlob);
    }
  }, [field]);

  const onChange = text => {
    setBlob(text);
    if (!isNil(field) && 'jsonBlob' in field) {
      // @ts-ignore
      updateField(component.id, { ...field, jsonBlob: text });
    }
  };

  return <TextInput onChangeText={onChange} value={blob}></TextInput>;
}
